import { Sparkles } from 'lucide-react';
import { TileActionIconButton } from '~/modules/moodboards/components/TileActionIconButton';
import { useBoostControl } from './boost-control-context';

/**
 * Boost Resolution as one of a picture's action discs, for a host that hands
 * it to a tile's action row (`shareLeading`). Draws nothing outside a
 * `BoostResolutionOverlay` set to `controlInActionPanel`, or for a reader who
 * cannot boost.
 */
export const BoostActionButton = () => {
    const boost = useBoostControl();
    if (!boost) return null;

    return (
        <TileActionIconButton
            label={boost.wasUpscaled ? 'Compare boost' : 'Boost Resolution'}
            icon={<Sparkles />}
            onClick={boost.activate}
        />
    );
};
